import React from "react";
export default function EmptyState({title="Nenhum registro encontrado.",description}){return <div className="p-8 text-center text-gray-500"><p className="font-medium text-gray-700">{title}</p>{description&&<p className="mt-1 text-sm">{description}</p>}</div>}
